import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackSelectFilter = ({ element, context, filterLvl, filtersValue, campaignId, }) => {
    const selectFilter = {
        context: context || getGA4Context(),
        element,
        // @ts-expect-error -- @pegasus/tracking-definitions does not support null.
        filter_lvl: filterLvl !== null && filterLvl !== void 0 ? filterLvl : null,
        filters_value: filtersValue,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-select_filter', {
        event_name: 'select_filter',
        select_filter: selectFilter,
    });
};
